<div class="tag">
    <a href="{{'videos-by-tag?tagId=' + tag._id+'&tagName='+tag.name}}"> {{tag.name}} </a>
    <img src="../../../assets/images/tag-i.png" />
</div>